export default __webpack_public_path__ + "images/twitter-icon_baa550bff7537e5b02c64fdbea7d0fdc.svg";